import styled from "styled-components";
import { narrowScreenMediaQuery, dark } from "../constants/styles";
import AuthImagePanel from "./AuthImagePanel";
import AuthPanel from "./AuthPanel";
import AuthHeader from "./AuthHeader";

// Split-screen shell used by Login, Signup, CheckInbox, and ConfirmEmail.
// `imageSide="left"` puts the photograph on the left (used on Login). Signup
// mirrors the layout (`imageSide="right"`) to match the approved mockup.
// On narrow screens both sides stack — the image becomes a 30vh banner above
// the form. Page remains scrollable on desktop too when the form is taller
// than the viewport (Signup has ~10 fields).
const Page = styled.div`
  min-height: 100vh;
  background: #fff;
  color: #1f2937;
  font-family: "Montserrat", sans-serif;
  display: flex;
  flex-direction: column;

  &[data-theme="dark"] {
    background: ${dark.page_bg};
    color: ${dark.text_primary};
  }
`;

const Split = styled.div`
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: ${({ $imageSide }) =>
    $imageSide === "right" ? "1fr 1fr" : "1fr 1fr"};
  min-height: calc(100vh - 64px);

  @media ${narrowScreenMediaQuery} {
    grid-template-columns: 1fr;
    min-height: auto;
  }
`;

const OrderedImage = styled.div`
  order: ${({ $imageSide }) => ($imageSide === "right" ? 2 : 1)};

  @media ${narrowScreenMediaQuery} {
    order: 1;
    height: 30vh;
    min-height: 220px;
  }
`;

const OrderedPanel = styled.div`
  order: ${({ $imageSide }) => ($imageSide === "right" ? 1 : 2)};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 48px;

  @media ${narrowScreenMediaQuery} {
    order: 2;
    padding: 32px 20px 48px;
  }
`;

export default function AuthLayout({
  imageSide = "left",
  crossLink,
  children,
}) {
  return (
    <Page>
      <AuthHeader crossLink={crossLink} />
      <Split $imageSide={imageSide}>
        <OrderedImage $imageSide={imageSide}>
          <AuthImagePanel />
        </OrderedImage>
        <OrderedPanel $imageSide={imageSide}>
          <AuthPanel>{children}</AuthPanel>
        </OrderedPanel>
      </Split>
    </Page>
  );
}
